<template>
  <v-dialog v-model="showDialog" max-width="40%">
    <template v-slot:activator="{ on }">
      <v-chip v-on="on" :color="tool.state.color" dark class="elevation-1">
        <v-icon left small>{{ tool.state.icon }}</v-icon>
        {{ tool.state.name }}
      </v-chip>
    </template>
    <v-card>
      <v-card-title>
        Update the status of the system
        <v-spacer />
        <v-btn icon @click="showDialog = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-select
            :items="states"
            :loading="loading"
            v-model="newState"
            item-value="id"
            item-text="name"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="warning" @click="showDialog = false">
          <v-icon left>close</v-icon>
          Close
        </v-btn>
        <v-btn text color="success" @click="saveState">
          <v-icon left>save</v-icon>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ToolState from "../../models/ToolState";
export default {
  name: "ToolStateChip",
  props: {
    tool: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      showDialog: false,
      loading: true,
      newState: this.tool.state.id
    };
  },
  computed: {
    states() {
      return ToolState.all();
    }
  },
  created() {
    ToolState.$fetch().then(() => {
      this.loading = false;
    });
  },
  methods: {
    saveState() {
      this.tool.constructor
        .$put(this.tool.name, { state: this.newState, name: this.tool.name })
        .then(() => {
          this.tool.constructor.$get(this.tool.name);
        })
        .finally(() => (this.showDialog = false));
    }
  }
};
</script>
